import { cva } from 'class-variance-authority';
import { cn } from '../../common/functions/cn';

export const buttonGroupVariants = cva(
  cn(
    // min-w-0 clears the UA's min-inline-size: min-content on fieldset, which preflight leaves alone.
    'flex w-fit min-w-0 items-stretch',
    // Lift the focused child so its ring is not clipped by the neighbour overlapping it.
    '*:focus-visible:relative *:focus-visible:z-10',
    // A group reads as one control, so a child must not dip away from the seam when it is pressed.
    '[&>[data-slot]:active:not([data-slot=button-group-separator])]:translate-y-0',
    'has-[>[data-slot=button-group]]:gap-2'
  ),
  {
    variants: {
      orientation: {
        horizontal: cn(
          '*:data-slot:rounded-e-none',
          '[&>[data-slot]:not(:has(~[data-slot]))]:rounded-e-md!',
          '[&>[data-slot]~[data-slot]]:rounded-s-none [&>[data-slot]~[data-slot]]:border-s-0',
          // The child before a checked one lends it a leading edge by recolouring the border they share, so a
          // selection closes its own outline without a child ever gaining a border to lay out around.
          '[&>[data-slot]:has(+[data-slot]_:checked)]:border-e-ring',
          // Each child but the last tints its trailing edge with its own ink, so the divider is a shade of
          // that button rather than the surface showing through the gap a transparent border would leave.
          '[&>[data-slot]:has(~[data-slot]):not(:has(:checked)):not(:has(+[data-slot]_:checked))]:border-e-current/12'
        ),
        vertical: cn(
          'flex-col *:data-slot:rounded-b-none',
          '[&>[data-slot]:not(:has(~[data-slot]))]:rounded-b-md!',
          '[&>[data-slot]~[data-slot]]:rounded-t-none [&>[data-slot]~[data-slot]]:border-t-0',
          '[&>[data-slot]:has(+[data-slot]_:checked)]:border-b-ring',
          '[&>[data-slot]:has(~[data-slot]):not(:has(:checked)):not(:has(+[data-slot]_:checked))]:border-b-current/12'
        ),
      },
    },
    defaultVariants: {
      orientation: 'horizontal',
    },
  }
);
